import { LicenseType } from '../../product';

export class SetSaasApiKey {
  static readonly type = '[SaasApi] Set API Key';
  constructor(public licenseType: LicenseType, public saasApiKey: string | null) {}
}
